import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import MultipleTabsAlert from './MultipleTabsAlert/MultipleTabsAlert';
import classes from './Workplace.module.scss';

const Workplace = React.forwardRef((props, iFrameRef) => {
  const {
    moduleSrc,
    impairedProps,
    isMultipleTab,
  } = props;
  const storedSrc = useRef('');
  const storedUrl = useRef('');
  const storedImpaired = useRef(impairedProps);

  let url = '';

  if (storedSrc.current !== moduleSrc || (impairedProps && !storedImpaired.current)) {
    url = `${moduleSrc}&timestamp=${Math.floor(Date.now() / 1000)}`;
    if (impairedProps) url += `$impaired=${impairedProps}`;
    storedImpaired.current = impairedProps;
    storedSrc.current = moduleSrc;
    storedUrl.current = url;
  } else {
    url = storedUrl.current;
  }

  /*
  useEffect(() => {
    //Удаляет из всех ссылок в учебниках (ebook) атрибут href иначе они не работают
    const links = document.querySelector('iframe').contentWindow.document.querySelectorAll('.link-redirect');
    for (let i = 0; i < links.length; i += 1) {
      links[i].removeAttribute('href');
    }
  });
  */

  //для разработки
  if (window.location.href.indexOf('http://localhost:3000/') !== -1) url = '';

  if (isMultipleTab) return <MultipleTabsAlert />;

  return (
    <iframe
      id="moduleIFrame"
      key={url}
      ref={iFrameRef}
      className={classes.Module}
      title="module"
      src={url}
      onLoad={props.onIframeLoad}
      frameBorder="0"
      allowFullScreen
    />
  );
});

export default React.memo(Workplace);

Workplace.propTypes = {
  onIframeLoad: PropTypes.func.isRequired,
  moduleSrc: PropTypes.string,
  moduleCode: PropTypes.string,
  impairedProps: PropTypes.string,
  isMultipleTab: PropTypes.bool.isRequired,
};

Workplace.defaultProps = {
  moduleSrc: '',
  impairedProps: null,
};
